<template>
  <div class="p-grid">
    <div class="p-col-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>

        <div class="col-6 col-admin-margin-left">
          <div class="p-card-field p-0">
            <label class="p-col-fixed txt-right p-0 m-0">Administrator</label>
            <div class="d-flex align-items-center">
              <div class="p-col new-select" style="flex-grow: 1;">

                <MultiSelect 
                :disabled="!role.add" 
                :multiple="true" 
                :clearable="false" 
               
                placeholder="Choose" 
                v-model="selectedUserAddPermission" 
                option-label="fullname"
                :options="listAdmin" 
                filter
           
                @filter="searchAdmin"
                >
                  <span slot="no-options" @click="$refs.select.open = false" display="chip" :filter="true">
                    Empty data
                  </span>
                </MultiSelect>
                <input class="input_tmp_validator" id="selectedUserAddPermission">
              </div>
              <div class="p-col-auto " v-if="role.add==true">
                <Button icon="pi pi-plus" class="p-button-success button-add-permission" @click="addUser()" />
              </div>
            </div>
          </div>
        </div>
        <!--{{listData}}-->
        <BaseDatatable :key="componentKey" :tableData="listData" :model="dataModel" :getFilterOptions="getFilterOptions"
          :actions="getRowActions()" :whereKeyList="whereKeyList" v-on:action-click="onActionClicked"
          @updateTitle="updateTitle" :dataUser="users" :usernew="user_new"></BaseDatatable>
        <!-- <Popup
          :key="editDialogKey"
          :show="displayDialog"
          :objKey="editId"
          :objModelName="modelName"
          :mode="dialogMode"
          @onChange="onChange()"
        ></Popup> -->

        <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Do you want to delete users permission <strong>{{ this.deleteName }}</strong>?
          <template #footer>
            <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
              class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import moment from "moment-timezone";

//import gql from "graphql-tag";
// import Popup from './popup'
export default {
  components: {
    BaseDatatable,
    // Popup
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Permissions', to: '/admin/list-permission' },
        { label: '' }
      ],
      filterOptions: {},
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      titleTmp: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      whereKeyList: {
        where_key: {
          /*accounts: {
            role: {_eq: "admin"},
            deleted: {_eq: false}
          },*/
          deleted: { _eq: false }
        }
      },
      page_transaction: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      selectedUserAddPermission: [],
      selectedUserPermission: [],
      listAdmin: [],
      listAdminAll: [],
      users: [],
      user_new: [],
      list_user_search : [],
    }
  },
  async mounted() {
    var group_id = this.$route.params.id;
    console.log('group_id', group_id);

    if (!this.$commonFuction.isEmpty(group_id)) {
      var where = { group_id: { '_eq': group_id } };
      var dataGroup = await this.$CoreService.getListData('group_user', where);
      var group_user = dataGroup;
      this.name = group_user[0]?.group?.name;
      this.$emit('updateTitle', this.name);
      for (let i = 0; i < group_user.length; i++) {
        let m = group_user[i];
        console.log('mmmmmmmmmmm', m);

        this.users.push({
          id: m?.user?.id,
          fullname: m?.user?.fullname
        })
      }
      // await this.getListAdmin();
    } 
    await this.getListAdmin();

    this.initParams();
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.items_bread_crumb[1].label = this.title;
    this.titleTmp = this.dataModel.name;
    this.$store.commit('setLoading', true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.ASSIGN_USER);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
    }
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false : true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false : true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false : true;
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    FilterChange(event) {
      alert('FilterChange');
      console.log('event', event);
    },
    customFilter(event) {
      const query = event.query?.toLowerCase() || '';  
      const filteredList = this.listAdminAll.filter(item => {
        const fullname = item.fullname?.toLowerCase();
        const account = item.account?.toLowerCase();
        return (fullname && fullname.includes(query)) || (account && account.includes(query));
      });
      this.listAdmin = filteredList; 
    },
    addUser() {
      if (Array.isArray(this.selectedUserAddPermission) && this.selectedUserAddPermission.length > 0) {
        this.selectedUserAddPermission.forEach(m => {
          m.is_new = true;
          this.users.push(m);
          this.user_new.push(m);
        });
        this.getListAdmin();
        this.selectedUserAddPermission = [];
        if (this.users.length > 0) {
          this.users.map(async m => {
            if (m?.is_new) {
              let objects = {
                uid: m?.id,
                group_id: this.$route.params.id,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user
              }
              await this.$apollo.mutate({
                mutation: DataServices.insertData('group_user'),
                variables: {
                  objects: objects
                }
              }).catch(async error => {
                console.log(error);
              });
            }
            this.$commonFuction.is_loading(false);
            // this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successly', life: 3000 });
            // this.$router.push({ path: `/admin/list-permission` });
          });
        }
        window.location.reload();
      } else {
        alert("not user selected");

      }
    },
    async searchAdmin(search, loading) {
      console.log(loading);
      
      console.log("Search input:", search);
      if (search) {
        
        const listUid = this.users.map(m => m.id);  // Lấy danh sách các UID đã có
        const where_key = {
          deleted: { _eq: false },
          role: { _eq: 'admin_child' },
          id: { _nin: listUid },
          _or: {
            // Sử dụng ilike để tìm kiếm fullname không phân biệt dấu
            fullname: { _iregex: this.$commonFuction.search(search.value) },
          }
        };

        let { data } = await this.$apollo.query({
          query: DataServices.getList('users', { fields: `id fullname accounts {id account}` }),
          variables: { where_key, orderBy: [{ created_at: 'desc' }] },
          fetchPolicy: "network-only"
        });

        const list = data[Object.keys(data)];

        // Chỉ thêm formatName để tìm kiếm, không thay đổi fullname hiển thị
        const list_assign = list.map(e => ({
          id: e.id,
          fullname: e.fullname,  // Giữ nguyên fullname có dấu
          account: e.accounts.account,
          formatName: this.normalizeString(e.fullname)  // Thêm formatName chỉ dùng cho tìm kiếm
        }));

        this.listAdmin = list_assign;  // Cập nhật danh sách hiển thị
        console.log('list_assign', list_assign);
      } else {
        this.listAdmin = this.listAdminAll;  // Hiển thị tất cả nếu không có tìm kiếm
      }
    }
    ,
    normalizeString(str) {
      return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    async getListAdmin(){
      var listUid = [];
      this.users.map(m => listUid.push(m?.id));
      console.log('listUidlistUidlistUid', this.users);
      console.log('listUidlistUidlistUid', listUid);
      
      var where_key = {
        deleted : {_eq : false},
        role: {_eq: 'admin_child'},
        id: {_nin: listUid}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('users',{"fields" : `id fullname accounts {id account}`}),
        variables: {
          where_key: where_key,
          orderBy:[{created_at : 'desc'}]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_assign = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_assign.push({
        id: e.id,
        fullname: e.fullname,
        account: e.accounts.account,
        normalizedFullname: this.normalizeString(e.fullname),
        normalizedAccount: this.normalizeString(e.accounts.account)
      });
      }
      this.listAdmin = list_assign;
      this.listAdminAll = list_assign;
    },
  
    delUser(index) {
      if (!this.users[index]?.is_new) {
        this.listDel.push(this.users[index])
      }
      this.users.splice(index, 1);
      this.getListAdmin();
      console.log('fffffffffffffffffffffffffff', this.users);

    },
    updateTitle(data) {
      if (data) {
        this.title = `${this.titleTmp} - ${data}`;
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      this.items_bread_crumb[1].label = this.title;
      this.titleTmp = this.dataModel.label;
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        result = field.options;
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (this.role.add) {
        // actions.header = { name: 'add', icon: 'plus', path: `/admin/list-permission/${this.$route.params.id}/user/add` };
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        // if (that.role.edit) {
        //   buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-permission/edit/`};
        // }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if (that.role.delete) {
          buttons.delete = { name: 'delete', icon: 'trash', key: 'uid' }
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString() } })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push(action.path)
            // console.log("action.path", action.path);
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async deleteData() {
      console.log('this.deleteId', this.deleteId);
      console.log('this.$route.params.id', this.$route.params.id);
      
      this.$commonFuction.is_loading(true);
      //this.tableAction
      var that = this;
      let variables = {
        'where_key': {
          'uid': { '_eq': this.deleteId },
          group_id: { _eq: this.$route.params.id }
        }
      };
      this.$apollo.mutate({
        mutation: DataServices.deleteData('group_user'),
        variables: variables
      }).then(async () => {
        that.showDeleteDialog = false;
        that.$commonFuction.is_loading(false);
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Delete data successly', life: 3000 })
        that.componentKey++;
      }).catch((error) => {
        console.error('ERROR: ', error)
        that.$toast.add({
          severity: 'error',
          summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        })
        that.$commonFuction.is_loading(false);
      });
    },
  },
  /*apollo: {
    listData: {
      query() {
        this.modelName = this.$route.meta.model;
        console.log('8*************************',this.modelName);
        return DataServices.getList(this.modelName);
      },
      variables () {
        // Use vue reactive properties here
        return this.whereKeyList;
      },
      update(data) {
        console.log('this.dataModel.tableName',data);
        var listData = data[this.dataModel.tableName]
        this.title = this.dataModel.label + ' '
        this.dataModel.processData(listData)
        this.$store.commit('setLoading', false);
        this.componentKey += 1;
        console.log('data[this.dataModel.tableName]',data[this.dataModel.tableName]);
        return data[this.dataModel.tableName]
      },
      fetchPolicy: 'network-only',
      error() {
        this.$store.commit('setLoading', false);
      },
      skip() {
        return !this.modelName
      }
    }
  }*/

}
</script>
<style lang="scss">
.p-calendar .p-datepicker {
  width: 280px;
  padding: 0px;
  padding-top: 5px;
}

.p-calendar .p-datepicker td,
.p-calendar .p-datepicker td a {
  padding: 0px !important;
}

.p-calendar .p-datepicker td span {
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;
}

.p-datepicker .p-datepicker-header {
  padding: 5px !important;
}
.p-formgrid {
  padding-top: 15px;
}

.main-style-button {
  background: #FFDF01;
}

.p-multiselect {
  // width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}

.p-col-fixed {
  font-weight: 700;
}



.p-radiobutton .p-radiobutton-box {
  position: relative;
  border: 3px solid #666666;
  background-color: #FFFFFF !important;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: -1px;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  box-shadow: none !important;
  appearance: none;
}

.p-radiobutton input:focus,
.p-radiobutton input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton-box:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton .p-radiobutton-box::after {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #FFFFFF;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.p-radiobutton .p-radiobutton-box.p-highlight::after {
  background-color: #FFDF01;
}

.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #666666;
  box-shadow: none !important;
}

.p-radiobutton {
  display: block;
}

.p-radiobutton-box.p-highlight.p-focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #666666 !important;
  background-color: #FFDF01;
}


.p-radiobutton {
  display: block;
  align-items: center;
  margin-right: 8px;
}

.p-radiobutton label {
  margin-left: 8px;
  vertical-align: baseline;
  position: relative;
  top: 2px;
}

.css_voucher1 {
  color: #666666;

  margin-top: 15px;

}

.p-field-checkbox,
.p-field-radiobutton {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}



.style_title_group_car_infomation {
  position: relative;
  margin-top: 10px;
  margin-bottom: 30px;
}

.style_title_group_car_infomation::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #d3d0d0;
  transform: translateX(-15px);
}

.p-multiselect {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.new-select {
  width: calc(100% - 50px) !important;
}

.p-col-auto {
  width: 50px;
  margin-left: 5px;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.remove-button {
  background: none;
  border: none;
  color: #333;
  margin-left: 8px;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}

.remove-button:hover {
  color: red;
}


.p-button-outlined .p-button-label {
    color: #000000 !important;
}
.col-admin-margin-left {
  margin-left:-22px !important
}

// multi select


</style>